import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LoginService } from '../services/login.service';
import { JwtService } from '../services/jwt.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private jwtService: JwtService, private router: Router) {}

  canActivate(): boolean {
    const token = localStorage.getItem('jwt');
    if (token && !this.jwtService.isTokenExpired(token)) {
      return true;
    }
    this.router.navigate(['/login']);
    return false;
  }
}

@Injectable({ providedIn: 'root' })
export class AdminGuard implements CanActivate {
  constructor(private loginService: LoginService, private router: Router) {}

  canActivate(): boolean {
    const user = this.loginService.user;
    if (user?.role === 1) {
      return true;
    }
    this.loginService.logout();
    this.router.navigate(['/']);
    return false;
  }
}

@Injectable({ providedIn: 'root' })
export class AgentGuard implements CanActivate {
  constructor(private loginService: LoginService, private router: Router) {}

  canActivate(): boolean {
    const user = this.loginService.user;
    // Allow Admin, Agent, Scouting, or Casting roles
    if (user?.role === 1 || user?.role === 3 || user?.role === 5 || user?.role === 6) {
      return true;
    }
    this.loginService.logout();
    this.router.navigate(['/']);
    return false;
  }
}

@Injectable({ providedIn: 'root' })
export class ResearchGuard implements CanActivate {
  constructor(private loginService: LoginService, private router: Router) {}

  canActivate(): boolean {
    const user = this.loginService.user;
    // Allow Admin or Research roles
    if (user?.role === 1 || user?.role === 4) {
      return true;
    }
    this.loginService.logout();
    this.router.navigate(['/']);
    return false;
  }
}
